import { Component, Input } from '@angular/core';
import { ConsoleLogger, LocalContext, RootContextBase, buildValidationKey } from '@skylab-shared/core';
import { ListenersRegistry } from '@skylab-shared/utils';
import { BehaviorSubject } from 'rxjs';
import { CreatorApi, CreatorStep } from '../creator.component';

@Component({
    template: '',
})
export abstract class CreatorStepComponentBase<TViewModel, TContext> extends ListenersRegistry(class { }) {
    @Input() public id!: string;
    @Input() public context!: TContext;
    @Input() public api!: CreatorApi;

    public viewModel!: TViewModel;
    public isStepReady$ = new BehaviorSubject(false);

    protected readonly localContext: LocalContext;
    protected readonly logger: ConsoleLogger;
    protected validationSun!: string;

    protected constructor(
        rootContext: RootContextBase
    ) {
        super();
        this.localContext = rootContext.createLocalContext();
        this.logger = new ConsoleLogger(this.constructor.name);
    }

    public ngOnDestroy(): void {
        this.localContext?.dispose();
        this.deregisterAllListeners();
    }

    protected stepReady(): void {
        this.isStepReady$.next(true);
    }

    public getValidationKey(propertyName: string): string | undefined {
        if (this.validationSun) {
            return buildValidationKey(this.validationSun, propertyName);
        }
        return undefined;
    }

    //#region save

    public isSaveActive(): boolean {
        return !this.api.steps.filter(step => !step.hideInTimeline).some(step => !step.active);
    }

    public save(): void {
        this.api.onSave.emit();
    }

    public abstract isFormValid(): boolean;
    // #endregion

    // #region navigation
    public firstActivation = true;
    public onStepActive(): void {
        this.firstActivation = false;
    }

    public nextStep(): void {
        this.api.onNextStep();
    }

    public previousStep(): void {
        this.api.onPreviousStep();
    }

    public changeStep(step: CreatorStep): void {
        this.api.changeStep(step);
    }

    public skip(): void {
        this.api.onSkip.emit();
    }

    public get hasPreviousStep(): boolean {
        return this.currentStepIndex > 0;
    }

    public get hasNextStep(): boolean {
        return this.currentStepIndex < this.api.steps.length - 1;
    }

    public get currentStepNumber(): number {
        return this.currentStepIndex + 1;
    }

    private get currentStepIndex(): number {
        return this.api.steps.findIndex(x => this.api.currentStep.id === x.id);
    }
    // #endregion
}
